import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-itfacility-revoke-review',
  templateUrl: './itfacility-revoke-review.component.html',
  styleUrls: ['./itfacility-revoke-review.component.scss']
})
export class ITFacilityRevokeReviewComponent implements OnInit {
public itfacilityreject_data:any={};
  constructor(public appservice:AppService, public toastr:ToastrService) { }
onApprove(){
  this.itfacilityreject_data.status='Approved';
  this.itfacilityreject_data.approvedby=this.appservice.username;
   this.appservice.getTable("api/Transaction/UpdateRevoke_forChecker?Status="+this.itfacilityreject_data.status+"&createdby="+this.appservice.username+"&id="+this.appservice.CheckerRevokeEdit).subscribe((res:any)=>{
    this.toastr.success("Approved successfully!");
    //this.appservice.get_finalItFacilitygrid();
    this.appservice.goback();
  //this.appservice.ITfacilityrejectGrid();
   });
  
  
}
onDecline(){
   this.itfacilityreject_data.status='Rejected';
  this.itfacilityreject_data.approvedby=this.appservice.username;
   this.appservice.getTable("api/Transaction/UpdateRevoke_forChecker?Status="+this.itfacilityreject_data.status+"&createdby="+this.appservice.username+"&id="+this.appservice.CheckerRevokeEdit).subscribe((res:any)=>{
    this.toastr.success("Approved successfully!");
    //this.appservice.get_finalItFacilitygrid();
    this.appservice.goback();
  //this.appservice.ITfacilityrejectGrid();
   });
  
}
back(){
  this.appservice.goback();
  this.appservice.ITfacilityrejectGrid();
  
}
onformload(){
  this.appservice.getTable("api/Transaction/Pr_Fetch_DataonEditfor_Revoke?id="+this.appservice.CheckerRevokeEdit).subscribe((res:any)=>{
    if(res!=""){
      
      const seperate=JSON.parse(res);
      this.itfacilityreject_data=seperate[0];
      console.log("The ITcheckerEdited datas", this.itfacilityreject_data)
    }
  });
}
  ngOnInit(): void {
    this.onformload();
  }
}
